import { useQuery } from "@tanstack/react-query";
import { getEDSData } from "../services/articles.service";
import { QueryKeys } from "./queryKeys";

export const useEDSData = (countryId: string, articleNumbers: string) => {
  return useQuery({
    queryKey: [QueryKeys.EdsData, countryId, articleNumbers],
    queryFn: () => getEDSData(countryId, articleNumbers),
    enabled: !!countryId && !!articleNumbers,
    gcTime: 1000 * 60 * 60 * 24, // 24 hours cache time
    staleTime: 1000 * 60 * 60 * 24, // 24 hours stale time
  });
};
